import React from 'react'

interface IProps {
    label?: string
    placeholder: string
    name: string
    value: string | number
    onChange: () => void
    type?: React.HTMLInputTypeAttribute
}

// Input para ser usado com REACT-HOOK-FORM
export default function Input(props: IProps): React.ReactElement {
    return (
        <label>
            <small className="small-2">{props.label}</small>
            <input className="input-login" {...props} type={props.type} placeholder={props.placeholder} value={props.value} />
        </label>
    )
}
